import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import { Button } from "../../common/Button/Button";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import downloadIcon from '../../assets/downloadIcon.png'
import { Info } from "react-feather";

const MergedResourceTable = (props) => {

    const [MergedResourceModal, setMergedResourceModal] = useState(false)

  const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

//   const rowData = props.data

  const data = props.firstTimeData
    const data2 = props.engagedData

    const [rowData, setRowData] = useState([]);
    const [resourseNames, setResourseNames] = useState([]);
    const [mergedData, setMergedData] = useState([]);

    useEffect(() => {
        const countMap = {};
      
        // Update countMap with counts from data
        if (data) {
          data.forEach(item => {
            countMap[item.resourse_name] = {
              first_time_count: item.resourse_count,
              engaged_count: 0
            };
          });
        }
      
        // Update countMap with counts from data2 or set engaged_count to 0 if not found
        if (data2) {
          data2.forEach(item => {
            if (countMap[item.resourse_name]) {
              countMap[item.resourse_name].engaged_count = item.resourse_count;
            } else {
              countMap[item.resourse_name] = {
                first_time_count: 0,
                engaged_count: item.resourse_count
              };
            }
          });
        }
      
        // Convert countMap back to an array
        const mergedData = Object.keys(countMap).map(resourse_name => ({
          resourse_name: resourse_name,
          first_time_count: countMap[resourse_name].first_time_count,
          engaged_count: countMap[resourse_name].engaged_count
        }));
      
        const resNames = mergedData.map(data => data.resourse_name);
        console.log("Res Name", resNames);
      setResourseNames(resNames);
      
        setRowData(mergedData);
        setMergedData(mergedData);
      }, [data, data2]);

  const footerRow = {
    resourse_name: "Total",
    first_time_count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.first_time_count, 0),
        engaged_count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.engaged_count, 0),
  };

  const openMergedResourceModalisTrue = () => {
    setMergedResourceModal(true)
  }

  const openMergedResourceModalisFalse = () => {
    setMergedResourceModal(false)
  }

  const handleClearClick = () => {
    props.setSelectedOptionsMergedResource([])
  }

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "resourse_name",
      headerName: "Resource Utilized",
      headerComponentFramework: (params) => {
        return (
            <div style={{ display: "flex",width: '50px', alignItems: "center" }}>
                <div style={{ marginRight: "240px" }}>{params.displayName}</div>
                <img
                alt=""
                src={ic_filter}
                height={"25px"}
                width={"25px"}
                className="conv-mr10"
                onClick={() => openMergedResourceModalisTrue()}
            />
            </div>
        );
      },
      width: 500,
      cellStyle: { 'white-space': 'normal' },
      autoHeight: true,
      cellRenderer: params => {
        let resourseName = params.value;
        if (resourseName === null) {
          resourseName = "Not Provided";
        }
        if (resourseName === "Total") {
          return <div style={{ textAlign: "right", display: 'none' }}>{resourseName}</div>;
        } else {
          return resourseName;
        }
      },
    },
    {
      field: "first_time_count",
      headerName: "No of First Time Users",
      // width: 180,
      flex:1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
        field: "engaged_count",
        headerName: "No of Engaged Users",
        // width: 280,
        flex: 1,
        sortable: true,
        pinnedBottomRowCellRenderer: "agGroupCellRenderer",
        cellStyle: { textAlign: "right" },
        headerComponentFramework: (params) => {
          return (
            <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
              <div>{params.displayName}</div>
            </div>
          );
        },  
    },
  ]);

  const handleMergedResourceSelect = (selected) => {
    props.setSelectedOptionsMergedResource(selected)
    console.log("select", props.selectedOptionsMergedResource)
  }

const handleMergedResourceFilterSearchClick = () => {
    if (props.selectedOptionsMergedResource.length > 0) {
        const filteredPartnerData = mergedData.filter((partner) =>
          props.selectedOptionsMergedResource.some((option) => option.value === partner.resourse_name)
        );
        console.log(filteredPartnerData);
        setRowData(filteredPartnerData);
      } else {
        setRowData(mergedData);
      }
      openMergedResourceModalisFalse();
  }

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

  // const handleDownloadCSV = () => {
  //   const csvData = [];
  //   csvData.push('Resource Utilized, No of First Time Users, No of Engaged Users'); // CSV header

  //   rowData.forEach(row => {
  //     csvData.push(`${row.resourse_name}, ${row.first_time_count}, ${row.engaged_count}`);
  //   });

  //   const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
  //   const csvUrl = window.URL.createObjectURL(csvBlob);

  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = csvUrl;
  //   downloadLink.download = 'resource_data.csv';
  //   downloadLink.style.display = 'none';
  //   document.body.appendChild(downloadLink);
  //   downloadLink.click();

  //   window.URL.revokeObjectURL(csvUrl);
  //   document.body.removeChild(downloadLink);
  // };

  const handleDownloadCSV = () => {
    const csvData = [];
    csvData.push('Resource Utilized, No of First Time Users, No of Engaged Users'); // CSV header

  
    rowData.forEach(row => {
      // Replace newlines in the 'resourse_name' with spaces
      const resourceName = row.resourse_name.replace(/\n/g, ' ');
      
      // Escape double quotes in the 'resourse_name' to avoid CSV issues
      const escapedResourceName = resourceName.replace(/"/g, '""');
  
      // Create the CSV row
      csvData.push(`${escapedResourceName}, ${row.first_time_count}, ${row.engaged_count}`);
    });

  
    const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
    const csvUrl = window.URL.createObjectURL(csvBlob);

  
    const downloadLink = document.createElement('a');
    downloadLink.href = csvUrl;
    downloadLink.download = 'resource_data.csv';
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();

  
    window.URL.revokeObjectURL(csvUrl);
    document.body.removeChild(downloadLink);
  };



  return (
    <div>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      // justifyContent: 'center',
      margin: 10
    }}>
    <h3 className="spled-colored-label" style={{
              fontSize: "20px",
              textAlign: 'center',
              marginRight: 10
          }}>2. First Time / Engaged users based on Resource Utilized </h3>
          <span style={{ cursor: "pointer" }} title="Display of first time users and engaged users based on Resource Availed">
          <Info style={{ width: "15px", marginRight: "10px", marginBottom:"5px" }} />
        </span>
          {
      rowData.length > 0 && (
        // <Button className="esp-inline-button"
        //   onClick={handleDownloadCSV}
        // >Download CSV</Button>
        <img src={downloadIcon} title="Download CSV" alt="" onClick={handleDownloadCSV} style={{
          cursor: "pointer"
        }}/>
      )
    }
    </div>

    <div style={{
      height: "50vh",
    }}>
      <div style={{ height: "100%", boxSizing: "border-box" }}>
        <div style={gridStyle} className="ag-theme-material">
          <AgGridReact ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            pinnedBottomRowData={[footerRow]}
            gridOptions={gridOptions}
            overlayNoRowsTemplate={
              '<span class="ag-overlay-loading-center">loading...</span>'
            }
            rowClassRules={{
              'total-row': 'data.resourse_name === "Total"'
            }}
          >
          </AgGridReact>
        </div>
      </div>

      <Modal isOpen={MergedResourceModal}>
        <ModalContent className="EngagedDashboard-filter-modal">
          <div className="modal-header">
            <span className="modal-title">Filter</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={openMergedResourceModalisFalse}
            />
          </div>

          <div className="modal-body">
            <br />
            <div className="row">
              <div className="col-12 spled-container">
                <div className="width-100">
                  <ReactMultiSelectCheckboxes
                    options={resourseNames.map((partner) => ({
                      label: partner,
                      value: partner,
                    }))}
                    // placeholder="Select partners"
                    placeholderButtonLabel="Select Resource"
                    value={props.selectedOptionsMergedResource}
                    onChange={handleMergedResourceSelect}
                  />
                </div>
              </div>
              {/* <div className="col-4 spled-container">
                <div className="width-100">
                  <Button className="esp-inline-button" onClick={handleClearClick}>Clear</Button>
                </div>
              </div> */}
            </div>
            <br />
            <div className='row d-flex justify-content-center align-items-center'>
              
              <div className="offset-1 col-5">
                <Button className="esp-inline-button" onClick={handleMergedResourceFilterSearchClick}>Search</Button>
              </div>
              <div className='col-5'>
                <Button className="esp-inline-button" onClick={handleClearClick}>Clear</Button>
              </div>
              {/* <div className='col-4'></div> */}
              {/* <div className="col-4"></div> */}
            </div>

          </div>
        </ModalContent>
      </Modal>
    </div>
    </div>
  )
}

export default MergedResourceTable
